// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2ZCUx","footer":"ChangeClinic_footer__1oNJi"};